import React from "react";
import { Box, Grid, Typography, useTheme } from "@mui/material";

interface InputWrapperProps {
  label: string;
  children: React.ReactNode;
  padding?: string;
}

const InputWrapper: React.FC<InputWrapperProps> = ({
  label,
  children,
  padding = "32px 16px",
}) => {
  const theme = useTheme();
  return (
    <Grid item xs={12}>
      <Box
        sx={{
          border: `1px solid ${theme.palette.text.tertiary}`,
          padding,
          display: "flex",
          flexDirection: "column",
          borderRadius: "4px",
          position: "relative",
        }}
      >
        <Typography
          variant="caption"
          sx={{
            padding: "5px",
            position: "absolute",
            top: 0,
            left: "10px",
            backgroundColor: theme?.palette.background.paper,
            transform: "translate(0, -50%)",
            color: theme.palette.text.primary,
          }}
        >
          {label}
        </Typography>
        <Grid container spacing={3} item xs={12}>
          {children}
        </Grid>
      </Box>
    </Grid>
  );
};

export default InputWrapper;
